/**
 * Premium Standalone Cart Page AJAX Controller
 */

class CartPageManager {
  constructor() {
    this.container = document.getElementById('MainCartContainer');
    if (!this.container) return;

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Quantity minus click
    this.container.addEventListener('click', (e) => {
      if (e.target.matches('[data-cart-qty-minus]')) {
        this.adjustQuantity(e.target, -1);
      }
      if (e.target.matches('[data-cart-qty-plus]')) {
        this.adjustQuantity(e.target, 1);
      }
      if (e.target.matches('[data-cart-remove]')) {
        this.removeItem(e.target);
      }
    });

    // Manual quantity inputs
    this.container.addEventListener('change', (e) => {
      if (e.target.matches('[data-cart-qty-input]')) {
        this.updateItemQuantity(e.target);
      }
    });

    // Auto-save Order notes on typing out (blur/change)
    this.container.addEventListener('change', (e) => {
      if (e.target.matches('[data-cart-note]')) {
        this.saveOrderNotes(e.target.value);
      }
    });
    this.container.addEventListener('blur', (e) => {
      if (e.target.matches('[data-cart-note]')) {
        this.saveOrderNotes(e.target.value);
      }
    }, true);
  }

  adjustQuantity(button, change) {
    const selector = button.closest('[data-quantity-selector]');
    const input = selector.querySelector('[data-cart-qty-input]');
    let currentQty = parseInt(input.value) || 1;
    let newQty = currentQty + change;
    
    if (newQty < 1) newQty = 1;
    input.value = newQty;

    const itemRow = button.closest('[data-cart-item-id]');
    const itemKey = itemRow.getAttribute('data-cart-item-id');
    this.updateCartItem(itemKey, newQty);
  }

  updateItemQuantity(input) {
    let val = parseInt(input.value) || 1;
    if (val < 1) val = 1;
    input.value = val;

    const itemRow = input.closest('[data-cart-item-id]');
    const itemKey = itemRow.getAttribute('data-cart-item-id');
    this.updateCartItem(itemKey, val);
  }

  removeItem(button) {
    const itemRow = button.closest('[data-cart-item-id]');
    const itemKey = itemRow.getAttribute('data-cart-item-id');
    this.updateCartItem(itemKey, 0);
  }

  updateCartItem(key, quantity) {
    // Show a subtle loading fade
    this.container.style.opacity = '0.5';

    const body = JSON.stringify({
      id: key,
      quantity: quantity
    });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(response => response.json())
    .then(() => {
      this.refreshPageMarkup();
    })
    .catch(error => {
      console.error('Error updating cart line item:', error);
      this.container.style.opacity = '1';
    });
  }

  saveOrderNotes(noteText) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: noteText })
    })
    .catch(error => {
      console.error('Error saving order notes:', error);
    });
  }

  refreshPageMarkup() {
    // Fetch refreshed section layout via Section Rendering API
    const sectionId = this.container.getAttribute('data-id');
    
    fetch(`/cart?sections=${sectionId}`)
    .then(response => response.json())
    .then(data => {
      const renderedHtml = data[sectionId];
      if (renderedHtml) {
        // Swap container inner HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = renderedHtml;
        const newContainer = tempDiv.querySelector('#MainCartContainer');
        
        if (newContainer) {
          this.container.innerHTML = newContainer.innerHTML;
          this.container.style.opacity = '1';
        }

        // Re-sync header cart count badge (if present)
        const headerCountBadge = document.querySelector('.header__icon--cart span[data-header-cart-count], .header__icon--cart .visually-hidden + span');
        const pageCountBadge = this.container.querySelector('.cart-page__count-badge');
        if (headerCountBadge) {
          headerCountBadge.textContent = pageCountBadge ? pageCountBadge.textContent : '0';
        }
      }
    })
    .catch(error => {
      console.error('Error refreshing cart page markup:', error);
      this.container.style.opacity = '1';
    });
  }
}

// Instantiate page manager on load
document.addEventListener('DOMContentLoaded', () => {
  window.cartPage = new CartPageManager();
});
